import { storeRef } from "@/components/providers/StoreProvider"
import { bookingActions } from "@/lib/redux/features/booking/reduce"
import { thunks } from "@/lib/redux/thunks"
import { getBookingSnapshot, saveBookingSnapshot } from "@/lib/pwa/bookingSnapshotStore"

export const getOrderDetail = async ({
  orderCode,
  phoneNumber,
}: {
  orderCode?: any
  phoneNumber?: any
}) => {
  const customEndpoint = (endpoint: string) =>
    `${endpoint}${orderCode}${phoneNumber ? `/${phoneNumber}/` : ''}`

  try {
    const result = await storeRef?.current
      ?.dispatch(
        thunks.order_detail({
          params: { customEndpoint },
        }),
      )
      .unwrap()

    storeRef.current?.dispatch(bookingActions.clearOrderDetailOfflineAt())

    if (result?.paymentStatus === 'PAID') {
      storeRef.current?.dispatch(bookingActions.removePendingOrders(result.orderCode))
    }

    await saveBookingSnapshot(String(orderCode), result, phoneNumber)

    return result
  } catch (error) {
    const snapshot = await getBookingSnapshot(String(orderCode), phoneNumber)

    if (snapshot) {
      storeRef.current?.dispatch(
        bookingActions.hydrateOrderDetailOffline({
          data: snapshot.data,
          savedAt: snapshot.savedAt,
        }),
      )
      return snapshot.data
    }

    throw error
  }
}
